var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.fields),function(item,key,index){return _c('p',{key:index},[_vm._v(" "+_vm._s(key)+": "),_c('span',{class:item < 0 && 'text-danger'},[_vm._v(" "+_vm._s(_vm._f("value")(item))+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }